module.exports = "/_next/static/images/e99de616a0629f8e2d30e165fb837251-hero-xs-1x.jpg";